import { Button } from '@repo/shared-client/components/ui'
import { cn } from '@repo/shared-client/lib/utils'
import { useTranslation } from '@web/src/lib/intl/react'
import { DownloadIcon, InfoIcon } from 'lucide-react'
import type { ComponentProps, MouseEvent } from 'react'
import { useState } from 'react'
import { usePwaInstall } from 'src/hooks/usePwaInstall'

import PwaInstallInstructionsModal from './pwa-install-instructions-modal'

type PwaInstallButtonProps = ComponentProps<typeof Button> & {
  installClicked?: () => void
}

const PwaInstallButton = (props: PwaInstallButtonProps) => {
  const { installClicked, className, ...rest } = props
  const { t } = useTranslation()
  const { isInstallable, isInstalled, installApp, isIOS } = usePwaInstall()
  const [showIOSInstructions, setShowIOSInstructions] = useState(false)

  if (!(isInstallable || isIOS) || isInstalled) return null

  const handleIOSInstructionsOpen = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setShowIOSInstructions(true)
  }

  // For iOS devices, we show instructions button
  if (isIOS) {
    return (
      <>
        <Button {...rest} className={cn(className)} onClick={handleIOSInstructionsOpen}>
          <InfoIcon />
          {t('How to Install App')}
        </Button>

        {/* iOS Installation Instructions Modal */}
        <PwaInstallInstructionsModal
          onGotItClicked={installClicked}
          onOpenChange={({ open }) => setShowIOSInstructions(open)}
          open={showIOSInstructions}
        />
      </>
    )
  }

  // For other devices that support installation
  return (
    <Button {...rest} className={cn(className)} onClick={installApp}>
      <DownloadIcon />
      {t('Install App')}
    </Button>
  )
}

export default PwaInstallButton
